import cognitoUtils from '../lib/cognito'

export const clearSession = () => ({
    type: "SIGN_OUT"
})

// Initialise the Cognito sesson from a callback href
export function initSessionFromCallbackURI(callbackHref) {
    return function (dispatch) {
        return cognitoUtils.parseCognitoWebResponse(callbackHref) // parse the callback URL
            .then(() => cognitoUtils.getCognitoSession()) // get a new session
            .then((session) => {
                dispatch({ type: "SIGN_IN", session })
            }).catch((error) =>{
                dispatch({ type: "invalid_grant", error })
            });
    }
}


export function signOut() {
    return function (dispatch){
        cognitoUtils.signOutCognitoSession();
        dispatch({type: "SIGN_OUT" });
    }
}


export const setSession = session => ({
    type: "SIGN_IN",
    session
})